// Copyright (c) Docugami, Inc. All rights reserved.

import { useSelector } from "react-redux";
import { AppState } from "store";
import { selectIsLimitedOrganization, maxPageLimitReached } from "store/AccountInfoHelpers";

interface PageLimitsInfo {
    pageUploadDisabled: boolean;
}

export function usePageLimits(): PageLimitsInfo {
    const organizationAccount = useSelector((state: AppState) => state.organizations.organizationAccount);
    const isLimitedOrganization = useSelector(selectIsLimitedOrganization)

    return {
        pageUploadDisabled: (maxPageLimitReached(organizationAccount) || isLimitedOrganization)
    }
}
